import { render, staticRenderFns } from "./UserBindingsBody.vue?vue&type=template&id=bf60c124&scoped=true"
import script from "./UserBindingsBody.vue?vue&type=script&lang=js"
export * from "./UserBindingsBody.vue?vue&type=script&lang=js"
import style0 from "./UserBindingsBody.vue?vue&type=style&index=0&id=bf60c124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf60c124",
  null
  
)

export default component.exports